import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import LoginContainer from "./LoginView/LoginContainer";
import withSplashScreen from "./LoginView/SplashScreen";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { Role } from "./AppContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import GiftHomePage from "./themes-views/Gifts/GiftHomePage";
import GiftWizard from "./themes-views/Gifts/GiftWizard";
import { GiftContextProvider } from "./themes-views/Gifts/Context/GiftContextProvider";
import GiftDone from "./themes-views/Gifts/GiftDone";
import AppContextProvider from "./context/AppContextProvider";
import MainLayout from "./MainLayout";
import * as Sentry from "@sentry/react";
import { ReactNode } from "react";
import GiftShare from "./themes-views/Gifts/GiftShare";
import TermsPage from "./themes-views/TermsPage";

const queryClient = new QueryClient();

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

const RoutesWrapper = ({ children }: { children: ReactNode }) => {
  const environment =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "development"
      : "production";
  if (environment === "production") {
    return <SentryRoutes>{children}</SentryRoutes>;
  } else {
    return <Routes>{children}</Routes>;
  }
};

const App = (props: { user: firebase.User & Role }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContextProvider user={props.user}>
          <GiftContextProvider>
            <RoutesWrapper>
              <Route element={<MainLayout />}>
                <Route path="login" element={<LoginContainer />} />
                <Route path="/gift" element={<GiftHomePage />} />
                <Route path="/gift/wizard" element={<GiftWizard />} />
                <Route path="/gift/done" element={<GiftDone />} />
                <Route path="/gift/share" element={<GiftShare />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="*" element={<Navigate to={"/gift"} />} />
              </Route>
            </RoutesWrapper>
          </GiftContextProvider>
        </AppContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default withSplashScreen(App);
